import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Sidebar = ({ isMobile = false, onNavigate = () => {} }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [openSections, setOpenSections] = useState({});

    const handleNavigation = (href) => {
        navigate(href);
        try { onNavigate(); } catch (e) { }
    };

    const toggleSection = (k) => setOpenSections((s) => ({ ...s, [k]: !s[k] }));

    const navigation = [
        {
            name: 'Dashboard',
            href: '/superadmin',
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5a2 2 0 012-2h4a2 2 0 012 2v2H8V5z"></path>
                </svg>
            ),
            current: location.pathname === '/superadmin'
        },
        {
            name: 'Tenants',
            href: '/superadmin/tenants', // No change made
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                </svg>
            ),
            current: location.pathname.startsWith('/superadmin/tenants')
        },
        {
            name: 'Analytics',
            href: '/superadmin/analytics',
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                </svg>
            ),
            current: location.pathname === '/superadmin/analytics'
        },
        {
            name: 'Settings',
            href: '/superadmin/settings',
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
            ),
            current: location.pathname === '/superadmin/settings'
        }
    ];

    if (isMobile) {
        // Mobile-friendly vertical menu (used inside header drawer)
        return (
            <div className="px-4 py-6">
                <nav aria-label="Main Nav" className="mt-6 flex flex-col space-y-1">
                    <button onClick={() => handleNavigation('/superadmin')} className="flex items-center gap-2 rounded-lg hover:bg-gray-100 px-4 py-2 text-gray-700">
                        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5a2 2 0 012-2h4a2 2 0 012 2v2H8V5z"></path></svg>
                        <span className="text-sm font-medium">Dashboard</span>
                    </button>

                    <button onClick={() => handleNavigation('/superadmin/tenants')} className="flex items-center gap-2 rounded-lg px-4 py-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 3h18v4H3zM3 11h18v10H3z"></path></svg>
                        <span className="text-sm font-medium">Tenants</span>
                    </button>

                    <button onClick={() => handleNavigation('/superadmin/analytics')} className="flex items-center gap-2 rounded-lg px-4 py-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M9 17v-6a2 2 0 00-2-2H5"></path></svg>
                        <span className="text-sm font-medium">Analytics</span>
                    </button>


                    <button onClick={() => handleNavigation('/superadmin/settings')} className="flex items-center gap-2 rounded-lg px-4 py-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700">
                        <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 8v4l3 3"></path></svg>
                        <span className="text-sm font-medium">Settings</span>
                    </button>
                </nav>
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full bg-white border-r border-gray-200 hidden lg:flex">
            {/* Logo/Brand */}
            <div className="flex items-center flex-shrink-0 px-4 py-5">
                <div className="flex items-center">
                    <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
                        <span className="text-white font-bold text-sm">SA</span>
                    </div>
                    <span className="ml-3 text-xl font-semibold text-gray-900">SuperAdmin</span>
                </div>
            </div>

            {/* Navigation */}
            <div className="flex-1 flex flex-col overflow-y-auto">
                <nav className="flex-1 px-2 py-4 space-y-1">
                    {navigation.map((item) => (
                        <button
                            key={item.name}
                            onClick={() => handleNavigation(item.href)}
                            className={`${
                                item.current
                                    ? 'bg-indigo-50 border-r-2 border-indigo-600 text-indigo-700'
                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                            } group flex items-center w-full px-2 py-2 text-sm font-medium rounded-md transition-colors`}
                        >
                            <div className={`${
                                item.current ? 'text-indigo-600' : 'text-gray-400 group-hover:text-gray-500'
                            } mr-3 flex-shrink-0`}>
                                {item.icon}
                            </div>
                            {item.name}
                        </button>
                    ))}
                </nav>
            </div>

            {/* User section at bottom */}
            <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
                <div className="flex items-center w-full">
                    <div className="flex-shrink-0">
                        <div className="w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center">
                            <span className="text-xs font-medium text-white">SA</span>
                        </div>
                    </div>
                    <div className="ml-3 flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-700 truncate">Super Admin</p>
                        <p className="text-xs text-gray-500 truncate">superadmin@stokraze.ng</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
